import React from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import FameWall from '../components/Frontend/FameWall';
import Testimonial from '../components/Frontend/Testimonial';
import VideoTuts from '../components/Frontend/VideoTuts';
import WhyLove from '../components/Frontend/WhyLove';
import { Link} from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
class Home extends React.Component {
    componentDidMount() {
        // ReactGA.initialize('UA-157984080-1');
        // ReactGA.pageview(window.location.pathname + window.location.search);
        ReactPixel.init('3847665161963731');
        ReactPixel.pageView();
    }
 render(){
    return (
    <React.Fragment>
    <Helmet htmlAttributes>
        <title>PTE Speaking Test Practice Material | LA Academy India</title>
        <meta name="description" content="Develop your speaking abilities with our PTE speaking test practice materials. LA Language Academy offers detailed resources for mastering the PTE Speaking Test." />
        <meta name="twitter:title" content="PTE Speaking Material for Practice | Best PTE Speaking Practice Test" />
        <meta name="og:title" content="PTE Speaking Material for Practice | Best PTE Speaking Practice Test" />
        <meta name="twitter:description" content="Are you facing issues in PTE Academic speaking module and worried about your exam score? No need to worry! With adequate practice and the right PTE speaking material, you can surely bolster your skills and ace this module in the exam. If you want the best PTE speaking practice test material & sample questions, or seeking expert assistance to attain your desired scores, contact us at info@languageacademy.com.au." />
        <meta property="og:description" content="Are you facing issues in PTE Academic speaking module and worried about your exam score? No need to worry! With adequate practice and the right PTE speaking material, you can surely bolster your skills and ace this module in the exam. If you want the best PTE speaking practice test material & sample questions, or seeking expert assistance to attain your desired scores, contact us at info@languageacademy.com.au." />
      </Helmet>
    <Header />
    <div class="innerPage">
    <section class="bannerOuter">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 text-center">
                        <h1>Brush up your English skills with the Best Online PTE Speaking practice test</h1>
                        <span>Avail the best PTE Speaking Material to practice, and score higher in the exam</span><br />
                        <a href="javascript:;" class="downArrow"><img src="images/banner-arrow.png" alt="banner-arrow" /></a>
                    </div>
                </div>
            </div>
        </section>
      </div>
      <section class="pteInfo">
         <div class="container">
            <div class="row">
              <div class="col-lg-10 col-lg-offset-1">
                  <p class="web-content">
                     Many aspirants perform well in writing, reading, and speaking modules, but when it comes to the PTE speaking test module, they find themselves all at sea. When they try to speak in English, they feel as if they have suddenly run out of words despite having a lot of thoughts in mind. Do you also face difficulties in converting your ideas to speech, and find yourself fumbling in the English speaking test? Don't get disappointed! Adequate practice with the right PTE speaking material is the key to overcome these issues.
                  </p>
                  <p class="web-content">
                     To boost your preparation and make yourself exam-ready, you need to practice a good number of PTE speaking sample questions so that you can avoid the long pauses or gaps while speaking in English. Moreover, you must couple your practice with a proper study plan, that includes attempting the mock tests or PTE speaking practice test sets at regular intervals, to accurately gauge your performance. For making a proper study plan to ace the exam, you can take guidance from the expert PTE trainers.
                  </p>
                  <p class="web-content">Are you searching for the top PTE tutors who can assist you with formulating a proper preparation plan and picking the right PTE academic speaking practice test material? Call us on <a style={{color: 'rgb(81, 203, 206)'}} href="tel:+61426230061" target="blank">+61 426230061</a> and get solutions to all your exam related queries.</p>
               </div>
            </div>
         </div>
      </section>
    <section id="pte-modules">
         <div class="container">
            <div class="row text-center">
               <div class="col-lg-4 col-sm-4">
                  <Link to="/pte-listening-test-practice-material">
                     <div class="module-wrapper">
                        <div class="module-icon">
                           <img src="images/listening.png" class="listening" />
                        </div>
                        <h3 class="module-title">Listening</h3>
                        <p class="module-description">Start preparing for the listening section using the latest practice material.</p>
                     </div>
                  </Link>
               </div>
               <div class="col-lg-4 col-sm-4">
                  <Link to="/pte-writing-test-practice-material">
                     <div class="module-wrapper">
                        <div class="module-icon">
                           <img src="images/writing.png" class="writing" />
                        </div>
                        <h3 class="module-title">Writing</h3>
                        <p class="module-description">Sharpen your writing skills with the best PTE writing practice material.</p>
                     </div>
                  </Link>
               </div>
               <div class="col-lg-4 col-sm-4">
                  <Link to="/pte-reading-test-practice-material">
                     <div class="module-wrapper">
                        <div class="module-icon">
                           <img src="images/reading.png" class="reading" />
                        </div>
                        <h3 class="module-title">Reading</h3>
                        <p class="module-description">Get the intensive PTE reading practice material to skyrocket your score.</p>
                     </div>
                  </Link>
               </div>
            </div>
         </div>
      </section>
    <WhyLove />
    <Testimonial />
    <Footer />
    </React.Fragment>);
    }
}

export default Home;
